import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cpfCnpj'
})
export class CpfCnpjPipe implements PipeTransform {

    transform(value: string, args?: any): any {
        if (value === null || value === undefined) {
            return value;
        }
        const cpfCnpj = value.replace(/\D/g, '');

        if (cpfCnpj.length === 11) {
            return cpfCnpj.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        } else if (cpfCnpj.length === 14) {
            return cpfCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }
        return value;
    }

}
